<!-- =========================================================================================
  File Name: SettingList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div v-if="showButtons" class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  entityList.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : entityList.length
                }}
                of {{ entityList.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />

        <vs-button
          class="mb-4 md:mb-0 ml-4 add-new-button"
          @click="addNewEntity"
          >Add New</vs-button
        >
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="entityList"
        rowSelection="multiple"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        @firstDataRendered="resizeColumns"
      >
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import Prompt from "@/components/general-components/modal/Prompt";

// Cell Renderer
import EntityCellRendererLink from "./cell-renderer/EntityCellRendererLink.vue";
import EntityCellRendererStatus from "./cell-renderer/EntityCellRendererStatus.vue";
import EntityCellRendererActions from "./cell-renderer/EntityCellRendererActions.vue";

export default {
  name: "EntityList",
  components: {
    AgGridVue,
    vSelect,
    Prompt,

    // Cell Renderer
    EntityCellRendererLink,
    EntityCellRendererStatus,
    EntityCellRendererActions
  },
  props: {
    entityList: {
      type: Array,
      default() {
        return [];
      }
    },
    columnDefs: {
      type: Array,
      default() {
        return [];
      }
    },
    entityName: {
      type: String,
      default: "Record"
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      searchQuery: "",
      entityToDelete: {},
      isDeleteEntityModalOpen: false,

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      // Cell Renderer Components
      components: {
        EntityCellRendererLink,
        EntityCellRendererStatus,
        EntityCellRendererActions
      }
    };
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    },
    activeUser() {
      return this.$store.state.AppActiveUser;
    }
  },
  methods: {
    addNewEntity() {
      this.$emit("addNew");
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    deleteEntity(entity) {
      this.$emit("delete", entity);
    },
    resizeColumns() {
      let allColumnIds = [];
      this.columnsApi.getAllColumns().forEach(column => {
        allColumnIds.push(column.colId);
      });
      this.columnsApi.autoSizeColumns(allColumnIds);
    }
  },
  beforeMount() {
    this.gridOptions = {
      context: {
        componentParent: this
      }
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.columnsApi = this.gridOptions.columnApi;
  },
  created() {}
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
#myButton {
  position: fixed;
  background: #28c76f !important;
  border-radius: 50%;
  min-height: 4.5rem;
  min-width: 4.5rem;
  bottom: 1rem;
  right: 2rem;
  z-index: 1000000;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  transition: 0.3s;
}

#myButton:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

#addIcon {
  margin: 0 auto;
}

.add-new-button {
  z-index: 500000;
}
</style>
